<script setup lang="ts">
import { getOptimizedImageSrc } from '@/directives/optimizedImageSize';
import { IProfile } from '@/interfaces';

interface Props {
  profile: IProfile;
  isSelected?: boolean;
  size?: 'small' | 'large';
  multiSelect?: boolean;
}

withDefaults(defineProps<Props>(), {});

const emit = defineEmits(['select-profile']);
</script>

<template>
  <button
    class="profile flex flex-col items-center"
    @click="emit('select-profile', profile)"
  >
    <img
      class="profileImage shadow-smallBottom rounded-full object-cover mb-4"
      :src="getOptimizedImageSrc(profile.displayImage, 'small')"
      :class="[
        size,
        { 'border-success': isSelected && multiSelect },
        { 'border-white': !isSelected },
      ]"
    />
    <p
      class="h700 text-center"
      :class="{
        'text-success font-bold': isSelected && multiSelect,
      }"
    >
      {{ profile.displayName }}
    </p>
  </button>
</template>

<style lang="scss" scoped>
.profile {
  .profileImage {
    &.small {
      width: 132px;
      height: 132px;
      border-width: 6px;
    }

    &.large {
      width: 214px;
      height: 214px;
      border-width: 8px;
    }
  }
}
</style>
